//Gets the thumbnail of a video file - created by ChatGPT :D

export default async function extractThumbnailUrlFromVideo(fileBlobUrl: string) {
    let thumbnailUrl = '';

    try {
        // Use a video element to capture the frame as an image
        const videoElement = document.createElement('video');
        videoElement.src = fileBlobUrl;

        // Ensure that the video metadata and first frame are loaded before setting the time
        // to capture the thumbnail at
        await new Promise((resolve, reject) => {
            videoElement.onloadedmetadata = resolve;
            videoElement.onerror = reject;
        });

        videoElement.currentTime = 0.1; // Set the time (in seconds) to capture the thumbnail

        const canvas = document.createElement('canvas');
        canvas.width = videoElement.videoWidth;
        canvas.height = videoElement.videoHeight;
        const context = canvas.getContext('2d');

        if (!context) {
            throw new Error('Failed to get canvas context');
        }

        // Required for Safari iOS, without this videoElement.onseeked will fail to fire
        videoElement.oncanplay = () => {
            videoElement.currentTime = 0.1;
            videoElement.oncanplay = null;
        };
        videoElement.src = fileBlobUrl;
        videoElement.load();

        // When the time to capture the thumbnail has been set wait for the frame to be drawn
        // before converting the canvas content to a data URL
        await new Promise((resolve, reject) => {
            videoElement.onseeked = () => {
                context.drawImage(videoElement, 0, 0, canvas.width, canvas.height);
                resolve('Finished drawing image to canvas');
            };
            videoElement.onerror = reject;
        });

        // Convert the canvas content to a data URL representing the image
        thumbnailUrl = canvas.toDataURL('image/jpeg');
    } catch (err) {
        console.error(err);
    }

    return thumbnailUrl;
}
